<nz-layout class="content-section">
  <nz-content>
    <div class="surprise-page-container">
      <div class="filters">
        <div class="select-container">
          <label class="select-label">Filter by Surprise</label>
          <nz-select
            class="border-black"
            [(ngModel)]="gridFilters.surprise"
            [nzSize]="'small'"
            [nzDropdownClassName]="'filter-select-dropdown'"
            style="width: 150px;"
            (ngModelChange)="surpriseGrid.onFilterChange(['percentChange'])"
          >
            <nz-option [nzLabel]="'Show All'" [nzValue]="'default'"></nz-option>
            <nz-option [nzLabel]="'More than 2%'" [nzValue]="'2'"></nz-option>
            <nz-option [nzLabel]="'More than 5%'" [nzValue]="'5'"></nz-option>
            <nz-option [nzLabel]="'More than 10%'" [nzValue]="'10'"></nz-option>
          </nz-select>
        </div>
        <div class="select-container">
          <label class="select-label">Filter</label>
          <nz-input-group
            class="border-black surprise-search-filter"
            [nzSuffix]="clearSuffixTemplate"
            [nzSize]="'small'"
          >
            <input
              [(ngModel)]="gridFilters.filterLineItem"
              nz-input
              placeholder="Search"
              (keyup)="surpriseGrid.onFilterChange(['lineitem'])"
            />
          </nz-input-group>
          <ng-template #clearSuffixTemplate
            ><i
              nz-icon
              nz-tooltip
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="gridFilters.filterLineItem"
              (click)="onClearLineitemSearch(surpriseGrid)"
            ></i
          ></ng-template>
        </div>
        <div
          class="show-more-periods"
          [class.disabled]="
            surpriseMeta.periods &&
            surpriseMeta.periods[0].includes(surpriseMeta.start_fiscal + '')
          "
        >
          <a (click)="surpriseGrid.onShowMorePeriodsClicked()"
            >Show More Periods</a
          >
        </div>
        <div class="yoy-switches">
          <div class="show-only-surprise">
            Show only % Surprise
            <nz-switch
              [ngModel]="gridFilters.onlySurprise"
              (ngModelChange)="onFilterChange($event, 'onlySurprise')"
            ></nz-switch>
          </div>
        </div>
      </div>
      <app-surprise-grid
        #surpriseGrid
        [surpriseMeta]="surpriseMeta"
        [gridFilters]="gridFilters"
      ></app-surprise-grid>
      <div class="info-vaactuals-calculation">
        ~ <i>VA Actuals uses point in time data </i
        ><a (click)="openVaActualCalculationInfo(true)">More Info</a>
      </div>
    </div>
  </nz-content>
  <nz-sider
    [hidden]="!showRightSidebar"
    [ngClass]="!disabledSidebar ? 'rightSider' : 'rightSider disabled'"
    nzTheme="light"
    nzCollapsible
    [(nzCollapsed)]="isRightsideBarCollapsed"
    [nzCollapsedWidth]="0"
    [nzZeroTrigger]="rightSiderArrowTemplate"
    (nzCollapsedChange)="rightSiderCollapseChanged($event)"
  >
    <app-right-panel></app-right-panel>
  </nz-sider>
  <ng-template #rightSiderArrowTemplate>
    <va-icon 
      [isFontAwesome]="true"
      [name]="faArrowCircleLeft"
      *ngIf="isRightsideBarCollapsed"
      class="fa fa-md"
    ></va-icon>
    <va-icon 
      [isFontAwesome]="true"
      [name]="faArrowCircleRight"
      *ngIf="!isRightsideBarCollapsed"
      class="fa fa-md"
    ></va-icon>
  </ng-template>
</nz-layout>
<nz-modal
  [(nzVisible)]="vaActualsInfoModalVisible"
  nzTitle="Point-in-time VA Actuals Logic"
  (nzOnCancel)="openVaActualCalculationInfo(false)"
  [nzFooter]="null"
>
<ng-container *nzModalContent>
  <p>
    VA Actuals on the surprise analysis page display point-in-time data, so users don’t see different surprise numbers at different times if a company restates its historical numbers for a period.
  </p>
  <p>
    Point in time includes broker data sent within 7 days post earnings release.
  </p>
  <p>VA Actuals on the grid pages display current data, and the values may differ from what is seen on surprise analysis for a particular period.</p>
</ng-container>
</nz-modal>
